import StickyAdsColumn from '../../../js/components/adBox/StickyAdsColumn';

export default StickyAdsColumn;
